import stVideoConferenceInvite from './videoConferenceInvite.component';

export default angular
  .module('st.VideoConference', ['st.Core'])
  .component('stVideoConferenceInvite', stVideoConferenceInvite)
  .service('videoConferenceService', ($q, $http, logger, dataService, VIDEOCONFERENCE) => ({
    invite: (params) =>
      dataService.apiRequest(null, null, true, null, $http.post, VIDEOCONFERENCE.API.INVITE, {
        params
      })
  }))
  .constant('VIDEOCONFERENCE', {
    API: {
      INVITE: '/api/v1/video-conference/invite/'
    }
  });
